import React from 'react'

export default function SendContainIcon({ width = 16, height = 14, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 13.3333V8.33333L6.66667 6.66667L0 5V0L15.8333 6.66667L0 13.3333Z" fill="#B8C4FF"/>
    </svg>
  )
}
